// Screen Types
export const ANALYTICS_SCREEN_TYPES = {
  HOMEPAGE: "homepage",
  USER_PROFILE: "user_profile",
  FAMILY: "family",
  DOCUMENTS: "documents",
  EMERGENCY_CARD: "emergency_card",
  PROFILE: "profile",
  REMINDER: "reminder",
  INSTALL: "install",
} as const;

// Screen Names
export const ANALYTICS_SCREEN_NAMES = {
  // Dashboard
  HOME: "home",

  // Profile - Main
  PROFILE: "profile",

  // Profile - Basic Information
  PROFILE_BASIC_INFO: "profile_basic_information",
  PROFILE_BASIC_INFO_IDENTITY: "profile:basic_information:edit_identity",
  PROFILE_BASIC_INFO_IDENTITY_COMPLETE:
    "profile:basic_information:edit_identity:edit_identity_complete",

  // Profile - Contact
  PROFILE_BASIC_INFO_CONTACT: "profile:basic_information:edit_contact",
  PROFILE_BASIC_INFO_CONTACT_VERIFY_MOBILE:
    "profile:basic_information:edit_contact:verify_mobile",
  PROFILE_BASIC_INFO_CONTACT_VERIFY_MOBILE_COMPLETE:
    "profile:basic_information:edit_contact:verify_mobile:verify_mobile_complete",
  PROFILE_BASIC_INFO_CONTACT_VERIFY_EMAIL:
    "profile:basic_information:edit_contact:verify_email",
  PROFILE_BASIC_INFO_CONTACT_VERIFY_EMAIL_COMPLETE:
    "profile:basic_information:edit_contact:verify_email:verify_email_complete",
  PROFILE_BASIC_INFO_CONTACT_COMPLETE:
    "profile:basic_information:edit_contact:edit_contact_complete",

  // Profile - Vitals
  PROFILE_BASIC_INFO_VITALS: "profile:basic_information:edit_vitals",
  PROFILE_BASIC_INFO_VITALS_COMPLETE:
    "profile:basic_information:edit_vitals:edit_vitals_complete",

  // Profile - Insurance
  PROFILE_BASIC_INFO_INSURANCE: "profile:basic_information:insurance",
  PROFILE_BASIC_INFO_INSURANCE_ADD_POLICY:
    "profile:basic_information:insurance:add_policy",
  PROFILE_BASIC_INFO_INSURANCE_DELETE_POLICY:
    "profile:basic_information:insurance:delete_policy",

  // Profile - Delete Account
  PROFILE_BASIC_INFO_DELETE_ACCOUNT: "profile:basic_information:delete_account",

  // Family
  FAMILY_HOME: "family_home",
  FAMILY_MEMBER_HOME: "family_member_home",
  FAMILY_MEMBER_MANAGE: "family_member_manage",
  FAMILY_OWNER_MANAGE: "family_owner_manage",
  FAMILY_INFO_EDIT: "family_info_edit",
  FAMILY_INFO_CONTACT_EDIT: "family_info_contact_edit",
  FAMILY_INFO_INVITE_AGAIN: "family_info_invite_again",
  FAMILY_INFO_INVITE_RESENT: "family_info_invite_resent",
  FAMILY_INFO_EDIT_NICKNAME: "family_info_edit_nickname",
  FAMILY_INFO_NICKNAME_ADDED: "family_info_nickname_added",
  FAMILY_INFO_FAMILY_NAME_EDIT: "family_info_family_name_edit",
  FAMILY_INFO_FAMILY_NAME_EDIT_COMPLETE:
    "family_info_family_name_edit_complete",
  FAMILY_INFO_MEMBER_DELETE: "family_info_member_delete",
  FAMILY_INFO_MEMBER_DELETE_CONFIRM: "family_info_member_delete_confirm",
  FAMILY_INFO_MEMBER_DELETE_CONFIRM_RESEND:
    "family_info_member_delete_confirm_resend",
  FAMILY_INFO_MEMBER_DELETE_COMPLETE: "family_info_member_delete_complete",
  FAMILY_NOTES: "family_notes",
  FAMILY_ADD_NOTES_CLICK: "family_add_notes_click",
  FAMILY_ADD_NOTES_DONE: "family_add_notes_done",
  FAMILY_ADD_MEMBER_RELATION: "family_add_member_relation",
  FAMILY_ADD_MEMBER_NAME: "family_add_member_name",
  FAMILY_ADD_MEMBER_BASIC_INFO: "family_add_member_basic_info",
  FAMILY_ADD_MEMBER_INVITE_MEMBER: "family_add_member_invite_member",
  FAMILY_ADD_MEMBER_ADD_CONTACT: "family_add_member_add_contact",
  FAMILY_ADD_MEMBER_COMPLETE: "family_add_member_complete",

  // Subscription
  SUBSCRIPTION_SCREEN_NAME: "first_install",
  SUBSCRIPTION_ACTION: "subscription_complete",

  // Documents
  DOCUMENTS_UPLOADS: "documents_uploads",
  DOCUMENTS_ADD_METHOD: "documents_add_method",
  DOCUMENTS_ADD_METHOD_PHOTO: "documents_add_method_photo",
  DOCUMENTS_ADD_METHOD_GALLERY: "documents_add_method_gallery",
  DOCUMENTS_ADD_METHOD_FILES: "documents_add_method_files",
  DOCUMENTS_ADD_METHOD_FILES_CONFIRM: "documents_add_method_files_confirm",
  DOCUMENTS_ADD_PROCESSING_STATUS: "documents_add_processing_status",
  DOCUMENTS_ADD_PROCESSING_EDIT_FILE: "documents_add_processing_edit_file",
  DOCUMENTS_ADD_PROCESSING_EDIT_FILE_DONE:
    "documents_add_processing_edit_file_done",
  DOCUMENTS_HOME: "documents_home",
  DOCUMENTS_ALL_RECORDS: "documents_all_records",
  HEALTH_MEMORY_HOME: "health_memory_home",
  HEALTH_MEMORY_ADD: "health_memory_add",
  HEALTH_MEMORY_ADD_CONFIRM: "health_memory_add_confirm",

  // Emergency Card
  EMERGENCY_CARD_CREATE_STEP_1: "emergency_card_create_step_1",
  LONG_TERM_CONDITION_POPUP: "long_term_condition_popup",
  MEDICINE_POPUP: "medicine_popup",
  PROCEDURE_POPUP: "procedure_popup",
  IMPLANT_POPUP: "implant_popup",
  EMERGENCY_NOTE_POPUP: "emergency_note_popup",
  INSURANCE_POPUP: "insurance_popup",

  // Health Profile
  BLOOD_GROUP: "blood_group",
  VITALS: "vitals",
  ALLERGIES_HOME: "allergies_home",
  ALLERGIES_ADD: "allergies_add",
  ALLERGIES_ADD_FOOD: "allergies_add_food",
  ALLERGIES_ADD_MEDICINE: "allergies_add_medicine",
  ALLERGIES_ADD_OTHERS: "allergies_add_others",
  LONG_TERM_CONDITION_ADD: "long_term_condition_add",
  LONG_TERM_CONDITION_ADD_COMPLETE: "long_term_condition_add_complete",
  MEDICINE_ADD: "medicine_add",
  MEDICINE_ADD_COMPLETE: "medicine_add_complete",
  PROCEDURE_ADD: "procedure_add",
  PROCEDURE_ADD_COMPLETE: "procedure_add_complete",
  IMPLANT_ADD: "implant_add",
  IMPLANT_ADD_COMPLETE: "implant_add_complete",
  EMERGENCY_NOTE_ADD: "emergency_note_add",
  EMERGENCY_NOTE_ADD_COMPLETE: "emergency_note_add_complete",
  EMERGENCY_CONTACT_ADD: "emergency_contact_add",
  EMERGENCY_CONTACT_ADD_COMPLETE: "emergency_contact_add_complete",
  EMERGENCY_CARD_VIEW: "emergency_card_view",
  EMERGENCY_CARD_SHARE: "emergency_card_share",

  // Reminders
  REMINDER_HOME: "reminder_home",
  REMINDER_ADD: "reminder_add",
  REMINDER_ADD_APPOINTMENT: "reminder_add_appointment",
  REMINDER_ADD_MEDICATION: "reminder_add_medication",
  REMINDER_ADD_MEDICATION_FREQUENCY: "reminder_add_medication_frequency",
  REMINDER_ADD_MEDICATION_TIME: "reminder_add_medication_time",
  REMINDER_ADD_MEDICATION_DATE: "reminder_add_medication_date",
  REMINDER_ADD_MEDICATION_SUMMARY: "reminder_add_medication_summary",
  REMINDER_ADD_MEDICATION_COMPLETE: "reminder_add_medication_complete",
  REMINDER_VACCINATION: "reminder_vaccination",
  REMINDER_ADD_VACCINATION: "reminder_add_vaccination",
  REMINDER_ADD_VACCINATION_COMPLETE: "reminder_add_vaccination_complete",
  REMINDER_ADD_INSURANCE: "reminder_add_insurance",
  REMINDER_ADD_INSURANCE_INFORMATION: "reminder_add_insurance_information",
  REMINDER_ADD_INSURANCE_DATE: "reminder_add_insurance_date",
  REMINDER_ADD_INSURANCE_SUMMARY: "reminder_add_insurance_summary",
  REMINDER_ADD_INSURANCE_COMPLETE: "reminder_add_insurance_complete",
} as const;

/**
 * Helper function to build insurance screen names dynamically
 * @param insuranceType - 'private' | 'government' | 'family'
 * @param action - 'select' | 'add_complete'
 */
export const getInsuranceScreenName = (
  insuranceType: "private" | "government" | "family",
  action: "select" | "add_complete"
): string => {
  if (action === "select") {
    return `profile:basic_information:insurance:add_policy:${insuranceType}`;
  }
  return `profile:basic_information:insurance:add_policy:${insuranceType}:add_complete`;
};

/**
 * Helper function to build add member contact screen names dynamically
 * @param contactType - 'phone' | 'email'
 */
export const getAddMemberContactScreenName = (
  contactType: "phone" | "email"
): string => {
  return `family_add_member_add_contact_${contactType}`;
};

/**
 * Helper function to build add member contact consent screen names dynamically
 * @param contactType - 'phone' | 'email'
 */
export const getAddMemberContactConsentScreenName = (
  contactType: "phone" | "email"
): string => {
  return `family_add_member_add_contact_${contactType}_consent`;
};

/**
 * Helper function to build reminder appointment screen names dynamically
 * @param appointmentType - 'DOCTOR_VISIT' | 'LAB_TEST' | 'THERAPY' | 'HEALTH_CHECKUP'
 * @param stage - 'select' | 'date' | 'summary' | 'complete'
 */
export const getReminderAppointmentScreenName = (
  appointmentType: string,
  stage: "select" | "date" | "summary" | "complete"
): string => {
  const typeMap: Record<string, string> = {
    DOCTOR_VISIT: "doctor",
    LAB_TEST: "lab_test",
    THERAPY: "therapy",
    HEALTH_CHECKUP: "health_checkup",
  };

  const type = typeMap[appointmentType] || appointmentType.toLowerCase();

  if (stage === "select") {
    return `reminder_add_appointment_${type}`;
  }
  return `reminder_add_appointment_${type}_${stage}`;
};

export type AnalyticsScreenType =
  (typeof ANALYTICS_SCREEN_TYPES)[keyof typeof ANALYTICS_SCREEN_TYPES];
export type AnalyticsScreenName =
  | (typeof ANALYTICS_SCREEN_NAMES)[keyof typeof ANALYTICS_SCREEN_NAMES]
  | string;
